import { render, staticRenderFns } from "./AverageCallDuration.vue?vue&type=template&id=c4e0db32&scoped=true"
import script from "./AverageCallDuration.vue?vue&type=script&lang=js"
export * from "./AverageCallDuration.vue?vue&type=script&lang=js"
import style0 from "./AverageCallDuration.vue?vue&type=style&index=0&id=c4e0db32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e0db32",
  null
  
)

export default component.exports